export const iconFontAwesomeMusicVideoSliders = (
	<i className="fa-solid fa-sliders"></i>
);
